import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    filters: [],
    albums: [],
    searchTerm: "",
    selectedCategory: null
  },
  actions: {
    async getAlbums({ commit }) {
      try {
        this.loading = true;
        const res = await axios.get(
          `/api/sheets/${process.env.VUE_APP_SHEET_ID}/items`
        );
        commit("setAlbums", res.data.items);
        commit("setFilters", res.data.filters);
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    }
  },
  mutations: {
    setAlbums(state, value) {
      state.albums = value;
    },
    setFilters(state, value) {
      state.filters = value;
    },
    setSearchTerm(state, value) {
      state.searchTerm = value;
    },
    setSelectedCategory(state, value) {
      state.selectedCategory = value;
    }
  }
});
